import React from "react";
import footer_logo from "../../images/logo-footer-crop.png";
import { WDP_TPNRD_NO_COST } from "../../configurations/MessageConstants";

function FarmerFooter() {
  return (
    <footer className="text-center">
      <img src={footer_logo} alt="footer-logo" />{" "}
      <span className="mt-5 footer-text">{WDP_TPNRD_NO_COST}</span>
    </footer>
  );
}
export default FarmerFooter;
